import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuardWithConfig } from 'angular-auth-oidc-client';
import { currentUserGuard } from '@/app/core/auth/guards/current-user.guard';
import { requireSuperAdmin } from '@/app/core/auth/guards/permission.guard';
import { PROTAX_CONFIG_ID } from '@/app/core/auth/auth-config-ids';

/**
 * Public landing at '' (also the OIDC redirect target — keeping it unguarded avoids the guard racing
 * the auth-code callback). The authenticated app lives under '/aplikacija'. Serbian URL slugs.
 */
export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('@/app/features/public/landing').then((m) => m.Landing)
    },
    {
        path: 'aplikacija',
        // ⚠️ …WithConfig, ne goli autoLoginPartialRoutesGuard: goli oblik razrešava konfiguraciju na
        // INDEKSU 0 i sam zove login, zaobilazeći AuthService. Radio je samo zato što ProTax slučajno
        // stoji prvi — čime bi redosled niza u provideAuth postao nosivi detalj celog `/aplikacija` podstabla.
        canActivate: [autoLoginPartialRoutesGuardWithConfig(PROTAX_CONFIG_ID), currentUserGuard],
        loadComponent: () => import('@/app/layout/main-layout').then((m) => m.MainLayout),
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'kontrolna-tabla' },
            {
                // Kanarinac za uski token (AB#6533). Namerno NIJE u meniju — dohvata se samo preko URL-a.
                path: 'asistent-proba',
                loadComponent: () => import('@/app/features/dev/assistant-canary').then((m) => m.AssistantCanary),
                data: { breadcrumb: 'Asistent (proba)' }
            },
            {
                path: 'kontrolna-tabla',
                loadComponent: () => import('@/app/features/dashboard/dashboard').then((m) => m.Dashboard),
                data: { breadcrumb: 'Kontrolna tabla' }
            },
            {
                path: 'pregled-nepokretnosti',
                loadComponent: () => import('@/app/features/properties/properties').then((m) => m.Properties),
                data: { breadcrumb: 'Pregled nepokretnosti', wide: true }
            },
            {
                path: 'evidencija-prijava',
                loadComponent: () => import('@/app/features/tax-returns/tax-returns').then((m) => m.TaxReturns),
                data: { breadcrumb: 'Evidencija prijava', wide: true }
            },
            {
                path: 'informacije-o-zonama',
                loadComponent: () => import('@/app/features/zones/zones').then((m) => m.Zones),
                data: { breadcrumb: 'Informacije o zonama', wide: true }
            },
            {
                // Podrška (Ticketing) — ekran je biblioteke, lenjo iz ZASEBNE tačke `/panel` (statički uvoz bi ga
                // vratio u početni bundle). Deep link `?requestId=123` otvara taj zahtev.
                path: 'podrska',
                loadComponent: () => import('@expertgroup/support/panel').then((m) => m.EgSupportPage),
                data: { breadcrumb: 'Podrška' }
            },
            {
                // Administracija — super-admin only (route guard + server-enforced Protax:SuperAdmin policy).
                path: 'administracija',
                canActivate: [requireSuperAdmin],
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'pravna-lica' },
                    {
                        path: 'pravna-lica',
                        loadComponent: () => import('@/app/features/admin/business-entities').then((m) => m.AdminBusinessEntities),
                        data: { breadcrumb: 'Pravna lica', wide: true }
                    }
                ]
            }
        ]
    },
    {
        path: 'zabranjen-pristup',
        loadComponent: () => import('@/app/shared/pages/access-denied').then((m) => m.AccessDenied)
    },
    {
        path: '**',
        loadComponent: () => import('@/app/shared/pages/not-found').then((m) => m.NotFound)
    }
];
